'use client';

import { useEffect } from 'react';

import { useLogger } from '@/analytics';
import { ErrorPage } from '@/app/components/error-page/ErrorPage';

export default function Error({ error }: { error?: unknown }) {
  const { addError } = useLogger();

  useEffect(() => {
    if ((error as Error | undefined)?.message) {
      addError(error, { component: 'Error' });
    }
  }, [addError, error]);

  return (
    <ErrorPage
      primaryMessage="Something has gone wrong... but we're on it!"
      secondaryMessage="Please wait a moment and try again."
      statusCode="500"
    />
  );
}
